import SvgIcon from "./SvgIcon";
import config from "./config";

export { config };

export default SvgIcon;